import styled from 'styled-components';

export const BaseOrganizationDiv = styled.div`
  width: 100%;
  padding: 32px 10vw 12px 10vw;
  border-left: 1px solid rgba(0, 0, 0, 0.15);
  border-top: 1px solid rgba(0, 0, 0, 0.15);
  min-height: 96vh;
`;

export const NoAccessContainer = styled.div`
  background-color: #fff;
  padding: 48px;
  margin: 32px auto;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  text-align: left;
`;
